import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideConfiguration } from '@shareview-health/configuration/shared';
import { provideApplicationInsights, provideShareViewAuthorization, provideShareViewInterceptors } from '@shareview-health/shared';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideApplicationInsights(environment.applicationInsights),
    provideRouter(appRoutes),
    provideShareViewAuthorization({
      issuer: environment.authorization.issuer,
      clientId: environment.authorization.clientId,
      scope: environment.authorization.scope,
      secureRoutes: [environment.apiBaseUrl],
    }),
    provideConfiguration(environment.apiBaseUrl),
    provideShareViewInterceptors(),
  ],
};
